import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=6fd80f44&scoped=true"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"
import style0 from "./Cookie.vue?vue&type=style&index=0&id=6fd80f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd80f44",
  null
  
)

export default component.exports